(function () {
  "use strict";

  var SECTION_SELECTOR = "[data-wb-footer]";

  function closeLocalization(form) {
    var buttons = form.querySelectorAll(".wb-footer__loc-btn");

    buttons.forEach(function (button) {
      var list = button.nextElementSibling;
      button.setAttribute("aria-expanded", "false");
      if (list) list.setAttribute("hidden", "true");
    });
  }

  function initLocalization(section) {
    var forms = section.querySelectorAll(".wb-footer__loc-form");

    forms.forEach(function (form) {
      if (form.__wbFooterLocInit) return;
      form.__wbFooterLocInit = true;

      var buttons = form.querySelectorAll(".wb-footer__loc-btn");
      var links = form.querySelectorAll(".wb-footer__loc-list a");

      buttons.forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();

          var expanded = button.getAttribute("aria-expanded") === "true";
          closeLocalization(form);

          if (!expanded) {
            var list = button.nextElementSibling;
            button.setAttribute("aria-expanded", "true");
            if (list) list.removeAttribute("hidden");
          }
        });
      });

      links.forEach(function (link) {
        link.addEventListener("click", function (event) {
          event.preventDefault();

          var value = link.getAttribute("data-value");
          var group = link.closest(".wb-footer__loc-group");
          var input = group ? group.querySelector('input[type="hidden"]') : null;

          if (!input || !value) return;

          input.value = value;
          form.submit();
        });
      });

      document.addEventListener("click", function (event) {
        if (!form.contains(event.target)) {
          closeLocalization(form);
        }
      });
    });
  }

  function initAccordions(section) {
    var buttons = section.querySelectorAll(".wb-footer__accordion-btn");

    buttons.forEach(function (button) {
      if (button.__wbFooterAccordionInit) return;
      button.__wbFooterAccordionInit = true;

      button.addEventListener("click", function () {
        var expanded = button.getAttribute("aria-expanded") === "true";
        var content = button.nextElementSibling;

        button.setAttribute("aria-expanded", expanded ? "false" : "true");

        if (!content) return;

        if (expanded) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    });
  }

  function initFooter(section) {
    if (!section) return;

    initLocalization(section);
    initAccordions(section);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initFooter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section) initFooter(section);
  });
})();